import { useState } from "react";
import ReactECharts from "echarts-for-react";
import * as S from "./PieChart.style";

interface PieChartProps {
  currentLabel?: string;
  totalLabel?: string;
  data?: any;
  total?: number;
  used?: number;
}

export const PieChart = ({
  currentLabel,
  totalLabel,
  data,
  total,
  used,
}: PieChartProps) => {
  const options = {
    tooltip: {
      trigger: "item",
    },
    color: ["#4B45E7", "#FF4D58", "#FFBC11", "#E6E6E6"],
    legend: {
      show: false,
    },
    series: [
      {
        name: "Access From",
        type: "pie",
        radius: ["100%", "70%"],
        avoidLabelOverlap: false,
        label: {
          show: false,
          position: "center",
        },
        emphasis: {
          label: {
            show: false,
          },
        },
        labelLine: {
          show: false,
        },
        data: data,
      },
    ],
  };

  return (
    <S.PieChartBox>
      <ReactECharts
        option={options}
        opts={{ renderer: "svg" }}
        style={{ width: "100%", height: "100%" }}
      />

      <S.PieChartStatusBox>
        <S.PieChartStatus>
          <S.PieChartCurrent>
            <span>{currentLabel}</span>
            {used}GB
          </S.PieChartCurrent>

          <S.StatusDivieder />

          <S.PieChartTotal>
            <span>{totalLabel}</span>
            {total}GB
          </S.PieChartTotal>
        </S.PieChartStatus>
      </S.PieChartStatusBox>
    </S.PieChartBox>
  );
};
